import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ContentTypeModels = {
  BILL: 'bill',
  BILLGROUP: 'billgroup',
  BILLPAYMENT: 'billpayment',
  ITEM: 'item',
  APPROVALDELEGATION: 'approvaldelegation',
  CUSTOMFIELD: 'customfield',
  EXPORTTASK: 'exporttask',
  COMPANYPAYMENTMETHOD: 'companypaymentmethod',
  CREDITCARD: 'creditcard',
  PAYMENT: 'payment',
  TRANSACTION: 'transaction',
  VENDORPAYMENTMETHOD: 'vendorpaymentmethod',
  PURCHASEAGREEMENT: 'purchaseagreement',
  PURCHASEAGREEMENTITEM: 'purchaseagreementitem',
  ACCOUNTCODE: 'accountcode',
  COMPANYACCOUNT: 'companyaccount',
  DEPARTMENT: 'department',
  EXPENSE: 'expense',
  EXPENSEREPORT: 'expensereport',
  ORDER: 'order',
  ORDERITEM: 'orderitem',
  PO: 'po',
  TAX: 'tax',
  TRAVEL: 'travel',
  VENDOR: 'vendor',
  VENDORREQUEST: 'vendorrequest',
  CREDITCARDITEM: 'creditcarditem',
  CARDTOPUPREQUEST: 'cardtopuprequest',
  REQUEST: 'request',
  CATALOGITEMS: 'catalogitems',
  PAYMENTTERM: 'paymentterm',
  CONTRACT: 'contract',
  LINKEDBANKACCOUNT: 'linkedbankaccount',
  // App-label-qualified: the reconcile app registers its own `creditcarditem`
  // content type ('reconcile' app label + 'creditcarditem' model) — audit-log
  // integration on the reconciliation match screen (BHV-043).
  RECONCILE_CREDITCARDITEM: 'reconcile/creditcarditem',
} as const

export type ContentTypeModelEnum = Enum<typeof ContentTypeModels>
